import { FormattedMessage, useIntl } from 'react-intl';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { PromotionPriceProps } from '../../../../models';

const useStyles = makeStyles((theme => ({
  originalPrice: {
    position: 'absolute',
    top: theme.spacing(1.25),
    left: theme.spacing(35.6),
    lineHeight: theme.spacing(2),
    fontSize: theme.spacing(2),
    fontWeight: 400,
    textDecoration: 'line-through',
    color: '#000000',
  },
  discountPrice: {
    position: 'absolute',
    top: theme.spacing(3),
    left: theme.spacing(31.25),
    lineHeight: theme.spacing(6),
    fontSize: theme.spacing(4.5),
    fontWeight: 700,
    color: '#5959EB',
  },
  unitPrice: {
    position: 'absolute',
    top: theme.spacing(8.75),
    left: theme.spacing(34),
    lineHeight: theme.spacing(2),
    fontSize: theme.spacing(2),
    fontWeight: 400,
    color: '#000000',
  },
})));

const DEFAULT_PRICE_CONFIG = {
  currentPrice: 2099,
  discountPrice: 1000,
  priceUnit: 'per license',
};

export const PromotionPrice = (props: PromotionPriceProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const {
    currentPrice,
    discountPrice,
    priceUnit,
  } = props;

  return (
    <>
      <Typography variant="h4" color="white" className={classes.originalPrice}>
        <FormattedMessage
          id="promotion.campaign.banner.price"
          values={{ price: intl.formatNumber(currentPrice ?? DEFAULT_PRICE_CONFIG.currentPrice) }}
        />
      </Typography>
      <Typography variant="h4" color="white" className={classes.discountPrice}>
        <FormattedMessage
          id="promotion.campaign.banner.price"
          values={{ price: intl.formatNumber(discountPrice ?? DEFAULT_PRICE_CONFIG.discountPrice) }}
        />
      </Typography>
      <Typography variant="h4" color="white" className={classes.unitPrice}>
        <FormattedMessage
          id="promotion.campaign.banner.price.unit"
          values={{ unit: priceUnit ?? DEFAULT_PRICE_CONFIG.priceUnit }}
        />
      </Typography>
    </>
  );
};
